import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, X } from "lucide-react";
import api, { avatarSrc } from "../lib/api";
import { VerifiedBadge } from "./VerifiedBadge";
import { OnlineDot } from "./OnlineDot";

export const ConnectionsModal = ({ userId, kind, onClose }) => {
  const [list, setList] = useState(null);
  useEffect(() => {
    if (!kind) return;
    setList(null);
    api.get(`/users/${userId}/connections`, { params: { kind } }).then((r) => setList(r.data)).catch(() => setList([]));
  }, [userId, kind]);
  if (!kind) return null;
  return (
    <div data-testid="connections-modal" className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="w-full max-w-md max-h-[75vh] flex flex-col bg-[#0F1014] border border-white/10 rounded-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/[0.06]">
          <h3 className="font-heading text-white uppercase tracking-widest text-sm">{kind}</h3>
          <button data-testid="connections-close" onClick={onClose} className="text-[#A1A1AA] hover:text-white"><X size={18} /></button>
        </div>
        <div className="overflow-y-auto p-2">
          {list === null && <div className="flex justify-center py-10"><Loader2 className="animate-spin text-[#00E5FF]" /></div>}
          {list?.length === 0 && <p className="text-center text-sm text-[#71717A] py-10">No {kind} yet</p>}
          {list?.map((u) => (
            <Link key={u.id} to={`/u/${u.username}`} onClick={onClose} data-testid={`connection-${u.username}`} className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-white/[0.04] transition-colors">
              <span className="relative shrink-0">
                {u.avatar_url ? <img src={avatarSrc(u.avatar_url)} alt={u.username} className="w-10 h-10 rounded-full object-cover" />
                  : <div className="w-10 h-10 rounded-full bg-[#0066FF] flex items-center justify-center text-white font-semibold">{u.username[0].toUpperCase()}</div>}
                <OnlineDot username={u.username} size={10} />
              </span>
              <div className="min-w-0">
                <p className="text-white text-sm font-semibold truncate flex items-center gap-1">{u.display_name}<VerifiedBadge show={u.verified} size={14} /></p>
                <p className="font-mono text-[11px] text-[#71717A]">@{u.username}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
